/* eslint-disable no-nested-ternary */
import React from 'react';
import styled from 'styled-components';
import WindowSize from '../../services/WindowSize';
import Navigation from '../../services/Navigation';
import UserAccount from '../../services/UserAccount';
import LogicBaseAppLists from '../../components/LogicBaseAppLists';
import LogicBaseCollectionCache from '../../services/cache/LogicBaseCollectionCache';
import Constants from '../../submodules/logictry_config/constants';

const Wrapper = styled.div`
  height: 100%;
  inset: 0;
  overflow: hidden;
  position: absolute;
`;
const Content = styled.div`
  inset: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  ${Constants.MediaMobile} {
    gap: 2rem;
  }
  padding-bottom: 4rem;
  min-height: 100%;
`;

export default class LogicBaseSearchPage extends React.PureComponent {
  state = {
    q: Navigation.currentLocation[1] === 'search' && Navigation.currentLocation[2] && unescape(Navigation.currentLocation[2]) || Navigation.currentSearch.q || '',
  }
  componentDidMount() {
    LogicBaseCollectionCache.onStateUpdate(this);
    WindowSize.onStateUpdate(this);
    UserAccount.onStateUpdate(this);
  }
  componentWillUnmount() {
    LogicBaseCollectionCache.offStateUpdate(this);
    WindowSize.offStateUpdate(this);
    UserAccount.offStateUpdate(this);
    if (this.subscriptions) this.subscriptions.offStateUpdate(this);
    this.subscriptions = null;
  }
  onPagination = () => {
    if (this.subscriptions && this.subscriptions.showMore && this.subscriptions.allFound && this.subscriptions.initialized) {
      this.subscriptions.getMore();
      this.forceUpdate();
    }
  }
  render() {
    const { mobile } = WindowSize;
    const { q } = this.state;
    const showTopics = (!q || q === 'topic');
    if (mobile) return <>
      <div style={{ top: (q || mobile) ? 0 : '3rem' }}>
        <LogicBaseAppLists />
      </div>
    </>;
    return (
      <Wrapper>
        <Content>
          <div style={{ top: (!showTopics || mobile) ? 0 : '3rem' }}>
            <LogicBaseAppLists />
          </div>
        </Content>
      </Wrapper>
    );
  }
}
